var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('p',[_vm._v(" Searching using these keywords: "),_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.$route.query.query))])]),_c('ContentSection')],1)}
var staticRenderFns = []

export { render, staticRenderFns }